// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"252e2083","371":"46750014","396":"48016166","453":"d6c2cc09","455":"81da1cb0","977":"eb5a4b42","989":"8d5a5257"}[chunkId] + ".chunk.js";
};